import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { OPEN_ALL_SECTIONS } from '../store/user';
import { UtlPerFinService } from './utl-per-fin.service';
import { Subscription } from 'rxjs/Subscription';
import { debounce } from 'app/common/other/decorators/decorators';

@Component({
  selector: 'app-utl-per-fin',
  templateUrl: './utl-per-fin.component.html',
  styleUrls: ['./utl-per-fin.component.css']
})
export class UtlPerFinComponent implements OnInit, OnDestroy {
  // header
  header: string = 'Utilization, Personnel and Finances';
  subHeader: string;
  // fullScreenMode: boolean = false;

  //At a glance paragraph
  paragraphText: string = '';

  // Used to manage state of full screen in all app
  currentUserUIScreen;

  // Spinner
  searchProgress = false;

  // Error Fetching Data?
  errorFetching = false;

  // Table Data
  table8data;

  // show hide Table Controls
  tableControlsOpen: boolean = true;

  // keep track of subscription to destroy them
  subscriptions: Subscription[] = [];

  // mobile settings
  columnHeaders: object[] = [];
  columnHeaderSelected: string;
  isMobile: boolean = false;

  // datasets
  datasets = [
    { region: '1', category: 'U.S Census Division 1' },
    { region: '2', category: 'U.S Census Division 2' },
    { region: '3', category: 'U.S Census Division 3' },
    { region: '4', category: 'U.S Census Division 4' },
    { region: '5', category: 'U.S Census Division 5' },
    { region: '6', category: 'U.S Census Division 6' },
    { region: '7', category: 'U.S Census Division 7' },
    { region: '8', category: 'U.S Census Division 8' },
    { region: '9', category: 'U.S Census Division 9' }
  ];
  dataSetSelected;

  // download component
  downloads: any;

  constructor(private store: Store<any>, private utlPerFinService: UtlPerFinService) {
    this.subscriptions.push(
      store.select('currentUser').subscribe(
        currentUser => {
          this.currentUserUIScreen = currentUser;
          this.setTableControlsOpen(currentUser);
        },
        error => {
          console.error(error);
        }
      )
    );
  }
  @HostListener('window:resize', ['$event'])
  @debounce(500)
  setMobile(event?) {
    let viewPortWidth = event ? event.target.innerWidth : document.documentElement.clientWidth;
    this.isMobile = viewPortWidth < 992;
  }

  ngOnInit() {
    // Set original dataset/category to region 1
    this.dataSetSelected = this.datasets[0];
    this.setMobile();
    this.getTableData(this.dataSetSelected.region);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      if (typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
  }

  setTableControlsOpen(currentUser) {
    this.tableControlsOpen = currentUser.tableControlsOpen;
  }

  getTableData(region) {
    const searchOpts = {
      startYear: '2022',
      tableId: 'msas',
      region: region
    };
    this.searchProgress = true;
    this.subscriptions.push(
      this.utlPerFinService.getTable8Data(searchOpts).subscribe(
        ({ data }) => {
          this.searchProgress = false;
          this.table8data = data.getTable8Data;
          this.paragraphText = this.table8data.tableDetails
            .replace(/\>\s+\</g, '><')
            .replace(/(\r\n|\n|\r)/gm, '')
            .trim();
          const htmlArray = this.table8data.tableTitle.split(':');
          this.header = htmlArray[0];
          this.subHeader = htmlArray[1];
          this.columnHeaders = this.table8data.data.section[0].row[0].cell;
          this.columnHeaderSelected = this.table8data.data.section[0].row[0].cell[0].label;
          this.downloads = this.table8data.download;
          this.errorFetching = false;
        },
        error => {
          console.error('error fetching from graphql', error);
          this.searchProgress = false;
          this.errorFetching = true;
        }
      )
    );
  }

  onChangeSelect(e, index) {
    e.preventDefault();
    this.dataSetSelected = this.datasets[index];
    this.getTableData(this.dataSetSelected.region);
  }

  onChangeSelectService(e, header) {
    e.preventDefault();
    this.columnHeaderSelected = header.label;
  }

  expandAll() {
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: true
      }
    });
  }

  collapseAll() {
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: false
      }
    });
  }

  refresh() {
    window.location.reload();
  }
}



// WEBPACK FOOTER //
// ./src/app/t8-utl-per-fin/utl-per-fin.component.ts